/* ZARRELAH theme JS */
(function () {
  "use strict";

  /* Mobile nav */
  var burger = document.querySelector(".z-burger");
  var nav = document.querySelector(".z-nav");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      nav.classList.toggle("is-open");
    });
  }

  /* Product angle thumbnails: swap main image, or play the product film */
  document.querySelectorAll("[data-piece]").forEach(function (piece) {
    var media = piece.querySelector(".z-piece__media");
    var main = piece.querySelector(".z-piece__main");
    var thumbs = piece.querySelectorAll(".z-piece__thumbs button");

    function removeVideo() {
      var vid = media.querySelector("video");
      if (vid) { vid.pause(); vid.remove(); }
      if (main) main.style.visibility = "visible";
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!main) return;
        var videoSrc = btn.getAttribute("data-video");
        thumbs.forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");

        if (videoSrc) {
          removeVideo();
          var vid = document.createElement("video");
          vid.src = videoSrc;
          vid.autoplay = true;
          vid.muted = true;
          vid.loop = true;
          vid.controls = true;
          vid.playsInline = true;
          media.appendChild(vid);
          main.style.visibility = "hidden";
          return;
        }

        removeVideo();
        var src = btn.getAttribute("data-src");
        if (!src) return;
        main.style.opacity = "0";
        setTimeout(function () {
          main.src = src;
          main.style.opacity = "1";
        }, 220);
      });
    });
  });

  /* Piece checklist: "All" toggles every piece */
  var pickAll = document.getElementById("pick-all");
  var pieceChecks = Array.prototype.slice
    .call(document.querySelectorAll('.z-waitlist__picks input[name="pieces"]'))
    .filter(function (c) { return c !== pickAll; });
  if (pickAll) {
    pickAll.addEventListener("change", function () {
      pieceChecks.forEach(function (c) { c.checked = pickAll.checked; });
    });
    pieceChecks.forEach(function (c) {
      c.addEventListener("change", function () {
        if (!c.checked) pickAll.checked = false;
        else if (pieceChecks.every(function (x) { return x.checked; })) pickAll.checked = true;
      });
    });
  }

  /* "Notify me" buttons: jump to waitlist and pre-check that piece */
  document.querySelectorAll("[data-notify]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var pieceName = btn.getAttribute("data-notify") || "";
      var target = document.getElementById("waitlist");
      pieceChecks.forEach(function (c) {
        if (c.value === pieceName) c.checked = true;
      });
      if (target) target.scrollIntoView({ behavior: "smooth" });
    });
  });

  /* Waitlist form: AJAX submit to Formspree */
  var form = document.querySelector(".z-waitlist__form-wrap");
  if (form) {
    form.addEventListener("submit", function (e) {
      var action = form.getAttribute("action") || "";
      /* If the form ID is still the placeholder, let it submit normally
         so the merchant notices it needs configuring. */
      if (action.indexOf("YOUR_FORM_ID") !== -1) return;
      e.preventDefault();
      var data = new FormData(form);
      fetch(action, {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          var success = document.querySelector(".z-waitlist__success");
          if (res.ok) {
            form.style.display = "none";
            var note = document.querySelector(".z-waitlist__note");
            if (note) note.style.display = "none";
            if (success) success.style.display = "block";
          } else {
            alert("Something went wrong. Please try again.");
          }
        })
        .catch(function () {
          alert("Something went wrong. Please try again.");
        });
    });
  }

  /* Carousels: sleek arrows for the collection and campaign sections */
  document.querySelectorAll(".z-carousel").forEach(function (car) {
    var track = car.querySelector(".z-carousel__track");
    var prev = car.querySelector(".z-car-btn--prev");
    var next = car.querySelector(".z-car-btn--next");
    if (!track || !prev || !next) return;

    function step() {
      var first = track.children[0];
      if (!first) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 8;
      next.disabled = track.scrollLeft >= max - 8;
    }
    prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      next.classList.remove("z-car-btn--pulse");
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
    track.addEventListener("scroll", function () {
      window.requestAnimationFrame(update);
    });
    window.addEventListener("resize", update);
    update();
  });

  /* Gentle reveal on scroll (transform only, content always visible) */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".z-reveal").forEach(function (el) {
      io.observe(el);
    });
  }
})();
